import { http } from "../utils/http";

export const updateAlarmAcknowledgeApi = async (data) => {
  try {
    const res = await http.post("/Notifications/update-aknowledgement", data);
    return res;
  } catch (error) {}
};
